/**
 * The CommunityAnnouncements container
 */
import { ErrorModal } from "@bkry/bowline-components/ErrorModal";
import { PaginationSection } from "@bkry/bowline-components/PaginationSection";
import { ScrollToTop as useScrollToTop } from "@bkry/bowline-components/Utils";
import {
  listCommunityAnnouncements,
  listCommunityAnnouncementsErrorReset,
} from "@bkry/bowline-redux/communityAnnouncements";
import { extractUrlParams, getEnv } from "@bkry/bowline-utils";
import { useSsrEffect } from "@issr/core";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { CommunityAnnouncementCard } from "../../components/CommunityAnnouncementCard";
import Page from "../../components/Page/Page-component";

const { getUrlFilterParams } = extractUrlParams;

/**
 * CommunityAnnouncements container used as app default landing page
 */
const CommunityAnnouncements = (props, context) => {
  const REACT_APP_PROJECT_ID = getEnv("REACT_APP_PROJECT_ID");
  useScrollToTop();
  const dispatch = useDispatch();
  const totalPages = useSelector(
    (state) => state?.communityAnnouncements?.totalPages
  );
  const currentPage = useSelector(
    (state) => state?.communityAnnouncements?.listPage
  );
  const history = useHistory();
  const searchParams = history.location.search;
  const urlParams = new URLSearchParams(history.location.search);
  const filters = getUrlFilterParams(searchParams);
  const pageNum = urlParams.get("page");
  const itemNum = urlParams.get("items") || "20";
  let { url } = useRouteMatch();
  const lang = useSelector((state) => state.i18nState.lang);
  const loadedList = useSelector(
    (state) => state?.communityAnnouncements?.loadedList
  );

  const dispatchApi = async () => {
    dispatch(
      listCommunityAnnouncements({
        projectId: REACT_APP_PROJECT_ID,
        pageNum: pageNum,
        itemNum: itemNum,
        sorting: {},
        filters: filters || {},
      })
    );
  };

  useSsrEffect(dispatchApi);
  useEffect(dispatchApi, [dispatch, pageNum, itemNum, lang, searchParams]);

  const communityAnnouncementIds = useSelector(
    (state) => state?.communityAnnouncements?.idsList
  );
  const error = useSelector(
    (state) => state?.communityAnnouncements?.listError
  );

  return (
    <Page id="CommunityAnnouncements" title="Community Announcement">
      <Container>
        <Row className="gy-3 my-3">
          {loadedList &&
            (communityAnnouncementIds?.length ? (
              communityAnnouncementIds?.map((communityAnnouncementId) => (
                <Col
                  sm={12}
                  md={4}
                  key={communityAnnouncementId}
                  className="mb-3"
                >
                  <CommunityAnnouncementCard
                    communityAnnouncementId={communityAnnouncementId}
                  />
                </Col>
              ))
            ) : (
              <p className="alert alert-danger text-center d-gird gap-2 col-md-6 col-xs-12 mx-auto">
                {context.t("There are currently no community announcements.")}
              </p>
            ))}
        </Row>

        <PaginationSection
          currentPage={currentPage}
          totalPages={totalPages}
          basePath={url}
          itemNum={itemNum}
        />
        <ErrorModal
          error={error}
          errorReset={listCommunityAnnouncementsErrorReset}
          customErrorBody={context.t(
            "There was a problem listing all the community announcements. Please contact support.gen3@samsung.com."
          )}
        />
      </Container>
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
CommunityAnnouncements.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default CommunityAnnouncements;
